/**
 * Fields Puck réutilisables pour le layout interne des composites
 * (`gap` + `alignItems`). À merger dans `fields` du bloc.
 */
import {
  FlexAlignField,
  GapIconField,
} from "@/components/cms-puck/fields/LayoutIconFields";
import { cmsNew } from "@/lib/cms/cms-new-i18n";
import type { CustomField } from "@measured/puck";

import type { LayoutAlign, LayoutGap } from "./types";

export function compositeInnerGapAlignFields(opts?: {
  /** Inclure alignItems (défaut true). */
  withAlignItems?: boolean;
  /** Nom de la prop px custom pour GapIconField. */
  gapCustomFieldName?: "gapCustomPx" | "gapRowCustomPx" | "gapColCustomPx";
}): Record<string, CustomField<unknown>> {
  const withAlign = opts?.withAlignItems !== false;
  const customFieldName = opts?.gapCustomFieldName ?? "gapCustomPx";

  const fields: Record<string, CustomField<unknown>> = {
    gap: {
      type: "custom",
      label: cmsNew(
        "cms.new.blocks.composite.gap",
        "Espacement entre éléments",
      ),
      render: ({ value, onChange }) => (
        <GapIconField
          label={cmsNew("cms.new.auto.label.espacement", "Espacement")}
          value={(value as LayoutGap) ?? "none"}
          onChange={onChange as (v: LayoutGap) => void}
          customFieldName={customFieldName}
        />
      ),
    },
  };

  if (withAlign) {
    fields.alignItems = {
      type: "custom",
      label: cmsNew(
        "cms.new.blocks.composite.alignItems",
        "Alignement des éléments",
      ),
      render: ({ value, onChange }) => (
        <FlexAlignField
          hideLabel
          value={(value as LayoutAlign) ?? "center"}
          onChange={onChange as (v: LayoutAlign) => void}
        />
      ),
    };
  }

  return fields;
}
